import {
  START_GET_PHARMACIES_LIST,
  SUCCESS_GET_PHARMACIES_LIST,
  ERROR_GET_PHARMACIES_LIST,
  START_CREATE_PHARMACY,
  SUCCESS_CREATE_PHARMACY,
  ERROR_CREATE_PHARMACY,
  START_UPDATE_PHARMACY,
  SUCCESS_UPDATE_PHARMACY,
  ERROR_UPDATE_PHARMACY,
  START_DELETE_PHARMACY,
  SUCCESS_DELETE_PHARMACY,
  ERROR_DELETE_PHARMACY,
  RESET_PHARMACY_STATE,
} from "Actions/PharmacyAction";

const initialState = {
  pharmaciesList: {
    loading: false,
    data: {},
    error: "",
  },
  createPharmacyData: {
    loading: false,
    data: {},
    error: "",
  },
  updatePharmacyData: {
    loading: false,
    data: {},
    error: "",
  },
  deletePharmacyData: {
    loading: false,
    data: {},
    error: "",
  },
};

export const PharmacyReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PHARMACY_STATE: {
      return {
        ...state,
        [action.key]: action?.payload || initialState[action.key],
      };
    }
    case START_GET_PHARMACIES_LIST: {
      let oldList = state?.pharmaciesList?.data;
      return {
        ...state,
        pharmaciesList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: "",
        },
      };
    }
    case SUCCESS_GET_PHARMACIES_LIST: {
      let oldList = state?.pharmaciesList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        pharmaciesList: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case ERROR_GET_PHARMACIES_LIST: {
      return {
        ...state,
        pharmaciesList: {
          loading: false,
          data: {},
          error: "",
        },
      };
    }
    case START_CREATE_PHARMACY: {
      return {
        ...state,
        createPharmacyData: {
          loading: true,
          data: {},
          error: "",
        },
      };
    }
    case SUCCESS_CREATE_PHARMACY: {
      let oldList = state?.pharmaciesList?.data;
      oldList.list = [action?.payload?.data, ...oldList?.list];
      oldList.filterd_record = oldList?.filterd_record + 1;
      return {
        ...state,
        createPharmacyData: {
          loading: false,
          data: action.payload,
          error: "",
        },
      };
    }
    case ERROR_CREATE_PHARMACY: {
      return {
        ...state,
        createPharmacyData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_PHARMACY: {
      return {
        ...state,
        updatePharmacyData: {
          loading: true,
          data: {},
          error: "",
        },
      };
    }
    case SUCCESS_UPDATE_PHARMACY: {
      let oldList = state?.pharmaciesList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        updatePharmacyData: {
          loading: false,
          data: action.payload,
          error: "",
        },
      };
    }
    case ERROR_UPDATE_PHARMACY: {
      return {
        ...state,
        updatePharmacyData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_DELETE_PHARMACY: {
      return {
        ...state,
        deletePharmacyData: {
          loading: true,
          data: {},
          error: "",
        },
      };
    }
    case SUCCESS_DELETE_PHARMACY: {
      let oldList = state?.pharmaciesList?.data;
      oldList.list = oldList?.list?.filter((item) => item?.id != action?.id);
      oldList.filterd_record = oldList?.filterd_record - 1;
      return {
        ...state,
        deletePharmacyData: {
          loading: false,
          data: action.payload,
          error: "",
        },
      };
    }
    case ERROR_DELETE_PHARMACY: {
      return {
        ...state,
        deletePharmacyData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    default: {
      return state || initialState;
    }
  }
};
